export const toRequired = <T>(fields: readonly (keyof T)[]) =>
  fields.reduce(
    (acc, field) => {
      acc[field] = true;
      return acc;
    },
    {} as Record<keyof T, true>,
  );
